import axios, { AxiosResponse } from 'axios';
import { api, onboardingApi } from '../../../v2.snapshot/js/jcs';

export interface EmailTokenValidation {
  adminUserId: string;
  adminUserEmail: string;
  passwordResetToken: string;
}

export function validateEmailToken(token: string): Promise<AxiosResponse<EmailTokenValidation>> {
  return axios.post(`${onboardingApi.v1}/onboarding/customers?data=${token}`);
}

export function logout(): Promise<AxiosResponse<void>> {
  return axios.post(`${api.url_v3}/logout`, undefined, { withCredentials: true });
}
